export type ContentType = "brand" | "news" | "product";

export interface ContentItem {
  id: string;
  type: ContentType;
  title: string;
  summary: string;
  cover: string;
  category: string;
  author: string;
  date: string;
  tags: string[];
  body: string[];
}

export const siteInfo = {
  name: "白峰美羽",
  nameEn: "BaiFeng MeiYu",
  slogan: "以美为峰，以羽为翼",
  intro:
    "白峰美羽，以东方审美为根，以现代工艺为翼，致力于为注重品质与文化的消费者打造兼具质感与温度的精品。",
  phone: "400-826-1968",
  email: "hello@baifengmeiyu.com",
  address: "浙江省杭州市西湖区云栖路 88 号 白峰美羽品牌中心",
  workTime: "周一至周五 09:00 - 18:00",
  establishYear: "2009",
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "品牌介绍", path: "/brand" },
  { label: "最新动态", path: "/news" },
  { label: "产品资讯", path: "/products" },
  { label: "关于我们", path: "/about" },
  { label: "联系我们", path: "/contact" },
];

export const brandCategories = ["全部", "品牌历史", "品牌文化", "品牌理念", "品牌使命"];
export const newsCategories = ["全部", "活动公告", "媒体报道", "品牌动态", "新品发布"];
export const productCategories = ["全部", "经典系列", "星选系列", "轻享系列", "限定系列"];

export const brandStories: ContentItem[] = [
  {
    id: "b1",
    type: "brand",
    title: "从一间工作室到一座品牌美学中心",
    summary:
      "2009 年，白峰美羽从杭州西郊一间不足六十平米的旧厂房工作室起步，用十六年时间，把对手工质感的执念，变成了一套可以被完整讲述的品牌美学体系。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20minimalist%20brand%20archive%20studio%20interior%20with%20warm%20beige%20walls%2C%20soft%20diffused%20daylight%2C%20linen%20samples%20on%20a%20wooden%20table%2C%20muted%20neutral%20tones%2C%20editorial%20brand%20photography%2C%20calm%20and%20refined%20atmosphere%2C%20high%20detail&width=1200&height=800&seq=brand-story-01&orientation=landscape",
    category: "品牌历史",
    author: "品牌内容组",
    date: "2025-09-18",
    tags: ["品牌历史", "美学", "手工"],
    body: [
      "2009 年的春天，三位在纺织与设计行业工作多年的伙伴，在杭州西郊租下了一间六十平米的旧厂房。没有招牌，没有样品间，只有一台老式的裁剪机与满墙的手绘稿。他们给这个开始取名为「白峰美羽」——白峰代表克制而清晰的标准，美羽代表轻盈、有呼吸感的质感。",
      "最初的两年，白峰美羽只做一件事：打磨基础面料。团队走遍长三角的纺织工厂，反复试验纱线密度与后整理工艺，最终确立了以天然纤维为主体的选材原则。这段沉默的时期，后来被内部称为「三年打底」。",
      "2015 年，品牌发布首个成体系的产品系列，第一次把「质感可以被讲述」这件事变成现实。此后，白峰美羽陆续在上海、成都、深圳建立品牌体验空间，让产品与空间、服务与文化相互呼应。",
      "2021 年，品牌美学中心在杭州落成。它不是一座展厅，而是一个开放式的创作与交流场域：一层是可触摸的材质图书馆，二层是设计与打样工坊，三层则定期举办面向公众的审美工作坊。",
      "今天，白峰美羽已经成长为一个覆盖产品、空间与内容的完整品牌。但团队的共识始终没有改变：真正的品质感，来自对细节的长期耐心，而不是一次性的惊艳。",
    ],
  },
  {
    id: "b2",
    type: "brand",
    title: "克制的审美：白峰美羽的设计哲学",
    summary:
      "我们相信好的设计应当后退一步，让使用者的生活成为主角。这种克制，体现在配色、结构与每一个交互细节里。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20design%20philosophy%20still%20life%20with%20paper%20swatches%20and%20neutral%20fabric%20folds%20on%20a%20soft%20gray%20surface%2C%20gentle%20window%20light%2C%20muted%20warm%20neutrals%2C%20quiet%20artistic%20composition%2C%20editorial%20photography&width=1200&height=800&seq=brand-story-02&orientation=landscape",
    category: "品牌理念",
    author: "设计中心",
    date: "2025-08-30",
    tags: ["设计", "审美", "克制"],
    body: [
      "白峰美羽的设计哲学可以浓缩为两个字：克制。我们避免过度装饰，也不追逐短期的视觉潮流，而是把注意力放在比例、留白与手感这些更耐久的地方。",
      "在配色上，品牌长期以低饱和的中性色为基底，仅在关键处使用一点暖金作为提示。这种处理让产品既能安静地融入日常，又能在需要时被一眼识别。",
      "在结构上，我们坚持「可被拆解」的思路：每一件产品都应当能清楚说明它为什么是这样的形状、为什么用这种材料。透明，是克制的前提。",
      "这种哲学同样延伸到内容与空间。品牌的每一个页面、每一面墙，都不急于把所有信息塞满，而是给使用者留下自行发现的空间。",
    ],
  },
  {
    id: "b3",
    type: "brand",
    title: "材质的诚实：我们如何选择每一块布",
    summary:
      "从纤维、纱线到后整理，白峰美羽建立了一套可追溯的选材标准，把「诚实」写进产品最基础的一层。",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20natural%20fabric%20texture%20samples%20in%20soft%20neutral%20tones%2C%20stacked%20linen%20and%20cotton%20swatches%2C%20warm%20daylight%2C%20minimal%20editorial%20material%20photography%2C%20clean%20and%20tactile&width=1200&height=800&seq=brand-story-03&orientation=landscape",
    category: "品牌文化",
    author: "材质研究组",
    date: "2025-07-22",
    tags: ["材质", "工艺", "可持续"],
    body: [
      "在白峰美羽，材质不是成本项，而是品牌表达的第一句话。我们为每种主要纤维建立了原料档案，记录产地、批次与后整理工艺，让每一块布都能被追溯到它的来处。",
      "选材的第一原则是亲肤与耐久。我们希望产品在长期使用后呈现自然的质感变化，而不是迅速失去形状。为此，团队会在真实环境中进行数月的使用测试。",
      "第二原则是可持续。我们优先选择可降解的天然纤维，并推动供应链减少水耗与化学助剂。到 2024 年，主体产品线的天然材质占比已超过八成。",
      "诚实意味着不掩饰。我们会如实标注材质构成与养护方式，哪怕这些信息并不讨巧，因为长期的信任远比一次成交重要。",
    ],
  },
  {
    id: "b4",
    type: "brand",
    title: "以用户为中心的体验准则",
    summary:
      "从一次到店咨询到一件产品的长期陪伴，白峰美羽把服务当成产品的一部分来设计。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20retail%20experience%20space%20with%20soft%20beige%20interior%2C%20wooden%20display%20shelves%2C%20quiet%20ambient%20lighting%2C%20calm%20premium%20brand%20showroom%2C%20editorial%20interior%20photography%2C%20muted%20neutral%20palette&width=1200&height=800&seq=brand-story-04&orientation=landscape",
    category: "品牌理念",
    author: "客户体验组",
    date: "2025-06-15",
    tags: ["体验", "服务", "用户"],
    body: [
      "我们把服务看作产品的一部分。用户与品牌真正的接触，往往不是在网上，而是在一次真实的咨询、一次耐心的讲解，甚至一次售后回访里。",
      "为此，白峰美羽为一线伙伴设计了完整的体验手册：如何倾听需求，如何给出不夸张的建议，如何记录并跟进用户的长期偏好。",
      "我们克制地进行推荐。不制造焦虑，不诱导过度消费，而是帮助用户找到真正适合长期使用的那一件。",
      "体验准则的核心只有一句话：把用户当作会长期相处的朋友，而不是一次性的订单。",
    ],
  },
  {
    id: "b5",
    type: "brand",
    title: "品牌使命：让东方审美被从容地看见",
    summary:
      "白峰美羽的使命，不是把东方元素堆砌成符号，而是让东方审美以从容、现代的方式走进日常生活。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20oriental%20aesthetic%20still%20life%20with%20ceramic%20vessel%20and%20dried%20branches%2C%20soft%20warm%20beige%20background%2C%20minimal%20composition%2C%20artistic%20editorial%20photography%2C%20serene%20and%20refined%20mood&width=1200&height=800&seq=brand-story-05&orientation=landscape",
    category: "品牌使命",
    author: "品牌内容组",
    date: "2025-05-09",
    tags: ["使命", "东方美学", "文化"],
    body: [
      "东方审美最好的表达，往往不在宏大的叙事里，而在日常的细节中：一只手的动作、一件衣服的垂坠感、一段留白的呼吸。",
      "白峰美羽的使命，是让这种审美被从容地看见。我们不把它做成标签，而是把它拆解成可以触摸的材质、可以感知的比例、可以使用的产品。",
      "为此，品牌持续与工艺师傅、设计师、内容创作者合作，记录并转译那些容易被忽略的审美经验。",
      "当一位用户说「这件东西让我觉得舒服」，对我们而言，就是使命被真正完成的时刻。",
    ],
  },
  {
    id: "b6",
    type: "brand",
    title: "向未来生长：品牌的可持续发展承诺",
    summary:
      "白峰美羽发布面向 2030 年的可持续路线图，从材料、生产到循环使用，给出可被验证的时间表。",
    cover:
      "https://readdy.ai/api/search-image?query=sustainable%20design%20concept%20with%20recycled%20natural%20materials%20and%20green%20leaf%20on%20minimal%20beige%20surface%2C%20soft%20natural%20light%2C%20calm%20editorial%20photography%2C%20muted%20warm%20neutral%20palette%2C%20hopeful%20tone&width=1200&height=800&seq=brand-story-06&orientation=landscape",
    category: "品牌使命",
    author: "可持续发展组",
    date: "2025-03-28",
    tags: ["可持续", "未来", "责任"],
    body: [
      "品牌不该只活在这一季。白峰美羽在 2025 年正式发布面向 2030 年的可持续路线图，把承诺变成可被检验的目标。",
      "在材料端，我们计划将主体产品线的天然与再生材质占比提升至九成以上，并建立更完整的供应链溯源体系。",
      "在生产端，我们推动合作工厂降低单位能耗与水耗，并逐步采用更温和的后整理工艺。",
      "在使用端，我们上线产品的养护与回收计划，鼓励更长周期的使用，而不是频繁更替。未来不是一句口号，而是一张需要逐年打勾的时间表。",
    ],
  },
];

export const newsItems: ContentItem[] = [
  {
    id: "n1",
    type: "news",
    title: "白峰美羽秋冬新品发布会圆满举行",
    summary:
      "以「静水流深」为主题，品牌在杭州美学中心发布本季新品系列，现场以材质与光影讲述东方质感。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20brand%20product%20launch%20event%20stage%20with%20soft%20beige%20backdrop%20and%20warm%20gold%20accent%20lighting%2C%20minimal%20premium%20presentation%2C%20editorial%20event%20photography%2C%20calm%20refined%20atmosphere&width=1200&height=800&seq=news-01&orientation=landscape",
    category: "活动公告",
    author: "品牌公关部",
    date: "2025-10-08",
    tags: ["新品发布", "活动", "秋冬"],
    body: [
      "10 月 8 日，白峰美羽「静水流深」秋冬新品发布会在杭州品牌美学中心举行。现场没有喧闹的声光，取而代之的是柔和的自然光与可触摸的材质样墙。",
      "本季新品延续了品牌一贯的克制语言：以低饱和的中性色为基底，在领口与细节处点缀少量暖金，强调安静而有层次的质感。",
      "发布会同步开启了为期两周的公众开放日，用户可预约进入材质图书馆，亲手感受不同纤维的手感与垂坠。",
      "品牌设计总监在现场表示：我们希望通过这一季，让更多人体会到「安静也可以很有力量」。",
    ],
  },
  {
    id: "n2",
    type: "news",
    title: "《东方质感》专访：对话白峰美羽设计团队",
    summary:
      "国内设计媒体《东方质感》走进品牌工坊，与白峰美羽设计团队聊了聊关于克制、材质与长期主义。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20interview%20scene%20with%20two%20people%20in%20conversation%20inside%20a%20minimal%20design%20studio%2C%20warm%20neutral%20interior%2C%20soft%20daylight%2C%20muted%20tones%2C%20documentary%20style%20photography&width=1200&height=800&seq=news-02&orientation=landscape",
    category: "媒体报道",
    author: "内容中心",
    date: "2025-09-26",
    tags: ["媒体", "专访", "设计"],
    body: [
      "近日，设计媒体《东方质感》刊载了长篇专访《克制的力量——对话白峰美羽设计团队》。",
      "文章从品牌 2009 年的工作室起点写起，梳理了白峰美羽十六年来在材质与比例上的坚持，并深入到打样工坊，记录了从手绘稿到成品的完整过程。",
      "在谈到行业普遍追求快速上新时，团队回应：我们更在意一件产品能不能被使用五年以上，而不是这一季能不能上热搜。",
      "该专访被视为理解白峰美羽品牌理念的一份重要文本，也被多家平台转载。",
    ],
  },
  {
    id: "n3",
    type: "news",
    title: "白峰美羽材质图书馆正式面向公众开放",
    summary:
      "位于杭州美学中心一层的材质图书馆开放预约，访客可触摸超过两百种天然与再生纤维样本。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20material%20library%20with%20organized%20fabric%20samples%20on%20light%20wooden%20shelves%2C%20warm%20neutral%20interior%2C%20soft%20ambient%20light%2C%20refined%20editorial%20interior%20photography%2C%20calm%20orderly%20composition&width=1200&height=800&seq=news-03&orientation=landscape",
    category: "活动公告",
    author: "品牌公关部",
    date: "2025-09-12",
    tags: ["活动", "空间", "材质"],
    body: [
      "白峰美羽材质图书馆于本月正式面向公众开放。图书馆位于杭州品牌美学中心一层，收藏并展示了超过两百种天然与再生纤维样本。",
      "访客可以在讲解员的引导下，触摸不同纱线密度、不同后整理工艺带来的手感差异，理解「质感」是如何被一步步做出来的。",
      "开放首周即收到超过一千份预约申请。品牌表示，材质图书馆会长期免费开放，并定期更新样本。",
      "预约通道已在官网与品牌小程序同步上线。",
    ],
  },
  {
    id: "n4",
    type: "news",
    title: "星选系列春季新色「暮山」上线",
    summary:
      "星选系列迎来春季新色「暮山」，以低饱和的灰蓝过渡到暖褐，呈现安静而有层次的春季质感。",
    cover:
      "https://readdy.ai/api/search-image?query=soft%20muted%20blue%20to%20warm%20brown%20gradient%20fabric%20drape%20on%20minimal%20beige%20surface%2C%20gentle%20natural%20light%2C%20quiet%20editorial%20product%20photography%2C%20refined%20neutral%20palette&width=1200&height=800&seq=news-04&orientation=landscape",
    category: "新品发布",
    author: "产品企划部",
    date: "2025-08-20",
    tags: ["新品", "星选系列", "春季"],
    body: [
      "星选系列春季新色「暮山」正式上线。颜色灵感来自春日傍晚的山影：从低饱和的灰蓝缓缓过渡到暖褐，安静而有层次。",
      "「暮山」采用品牌自研的柔光后整理工艺，在保留天然纤维手感的同时，让色泽在自然光下呈现细腻的过渡。",
      "该配色首批发售覆盖星选系列的主要品类，并提供配套的养护建议卡。",
      "品牌提示：由于天然材质的特性，不同批次间可能存在细微色泽差异，这属于正常现象。",
    ],
  },
  {
    id: "n5",
    type: "news",
    title: "白峰美羽入选「年度品质品牌」榜单",
    summary:
      "在今年的行业评选中，白峰美羽凭借稳定的产品品质与长期主义理念，入选「年度品质品牌」榜单。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20award%20trophy%20on%20a%20soft%20beige%20pedestal%20with%20warm%20lighting%2C%20elegant%20understated%20celebration%20scene%2C%20editorial%20product%20photography%2C%20muted%20neutral%20tones%2C%20refined%20composition&width=1200&height=800&seq=news-05&orientation=landscape",
    category: "媒体报道",
    author: "品牌公关部",
    date: "2025-07-30",
    tags: ["荣誉", "媒体", "品质"],
    body: [
      "在今年的行业年度评选中，白峰美羽入选「年度品质品牌」榜单。评审委员会给出的评语是：以长期主义对抗短期潮流，把品质当作一种态度。",
      "品牌负责人在获奖致辞中表示，这份荣誉属于所有坚持在细节上的伙伴，也属于愿意长期使用我们产品的用户。",
      "评选同期发布了行业品质白皮书，白峰美羽的材质追溯体系被作为案例收录。",
    ],
  },
  {
    id: "n6",
    type: "news",
    title: "品牌体验空间落地成都远洋太古里",
    summary:
      "白峰美羽西南地区首家品牌体验空间正式开业，以「可触摸的审美」为空间设计主题。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20premium%20retail%20store%20interior%20with%20warm%20beige%20walls%20and%20wooden%20display%2C%20soft%20ambient%20lighting%2C%20calm%20elegant%20brand%20space%2C%20editorial%20interior%20photography%2C%20muted%20neutral%20palette&width=1200&height=800&seq=news-06&orientation=landscape",
    category: "品牌动态",
    author: "空间设计组",
    date: "2025-07-05",
    tags: ["空间", "成都", "体验"],
    body: [
      "白峰美羽西南地区首家品牌体验空间在成都远洋太古里正式开业。空间以「可触摸的审美」为主题，设置了材质墙、试穿区与安静的休息角。",
      "设计师在空间中使用大量留白与天然材质，让访客可以放慢脚步，慢慢感受产品的手感与比例。",
      "开业期间，空间同步举办了小型的材质工作坊，邀请本地用户参与。",
      "品牌表示，未来将持续在更多城市落地体验空间，让产品与用户之间的连接更加真实。",
    ],
  },
  {
    id: "n7",
    type: "news",
    title: "白峰美羽启动产品养护与回收计划",
    summary:
      "面向长期使用，品牌上线养护指南与旧品回收计划，鼓励延长产品使用寿命，减少一次性消费。",
    cover:
      "https://readdy.ai/api/search-image?query=hands%20folding%20natural%20fabric%20neatly%20with%20care%20instructions%20card%2C%20soft%20warm%20light%2C%20minimal%20beige%20background%2C%20editorial%20sustainability%20photography%2C%20gentle%20calm%20mood&width=1200&height=800&seq=news-07&orientation=landscape",
    category: "品牌动态",
    author: "可持续发展组",
    date: "2025-06-18",
    tags: ["可持续", "养护", "回收"],
    body: [
      "白峰美羽正式启动产品养护与回收计划。品牌为每一类材质提供了详细的养护指南，帮助用户在日常中延长产品的使用周期。",
      "同时，用户可将不再使用的产品寄回指定体验空间，品牌会视状况进行专业养护、再流通或环保回收。",
      "参与回收的用户将获得相应的品牌积分，用于后续的养护服务。",
      "品牌希望借此传递一个朴素的观点：最好的环保，是让一件东西被用得更久。",
    ],
  },
  {
    id: "n8",
    type: "news",
    title: "限定系列「霜白」限量发售",
    summary:
      "以冬日的晨霜为灵感，限定系列「霜白」限量发售，全球仅推出 500 套，每套附独立编号证书。",
    cover:
      "https://readdy.ai/api/search-image?query=limited%20edition%20frost%20white%20product%20presentation%20with%20numbered%20certificate%20card%2C%20minimal%20soft%20gray%20background%2C%20cool%20gentle%20lighting%2C%20elegant%20editorial%20photography%2C%20quiet%20refined%20mood&width=1200&height=800&seq=news-08&orientation=landscape",
    category: "新品发布",
    author: "产品企划部",
    date: "2025-05-22",
    tags: ["限定", "新品", "收藏"],
    body: [
      "以冬日清晨的霜白为灵感，白峰美羽推出限定系列「霜白」，全球限量 500 套，每套附独立编号证书。",
      "该系列采用品牌最高等级的天然材质，并以更为精细的手工工艺完成收边处理，呈现近乎无痕的质感。",
      "发售同时开启线上预约，品牌强调限定系列不追求数量，而希望每一套都能被认真使用与收藏。",
    ],
  },
  {
    id: "n9",
    type: "news",
    title: "品牌创始人受邀出席东方美学论坛",
    summary:
      "白峰美羽创始人受邀出席东方美学论坛，分享品牌如何在现代生活中转译传统审美经验。",
    cover:
      "https://readdy.ai/api/search-image?query=speaker%20on%20a%20minimal%20stage%20at%20an%20elegant%20design%20forum%2C%20warm%20neutral%20backdrop%2C%20soft%20spotlight%2C%20calm%20professional%20atmosphere%2C%20editorial%20event%20photography%2C%20muted%20tones&width=1200&height=800&seq=news-09&orientation=landscape",
    category: "媒体报道",
    author: "内容中心",
    date: "2025-04-16",
    tags: ["论坛", "美学", "分享"],
    body: [
      "白峰美羽创始人受邀出席东方美学论坛，以「转译」为题发表演讲，分享品牌如何把传统审美经验转化为当代可用的产品与空间语言。",
      "演讲中，创始人以材质与留白为例，说明审美不是复制符号，而是理解其背后的秩序，再用现代的方式重新表达。",
      "论坛同期举办了小型展览，白峰美羽的材质样墙作为展项之一，吸引了不少设计从业者驻足。",
    ],
  },
];

export const productItems: ContentItem[] = [
  {
    id: "p1",
    type: "product",
    title: "经典系列 · 云舒基础款",
    summary:
      "以长绒棉为主体的日常基础款，柔光后整理带来细腻触感，是品牌最具代表性、也最耐用的入门之选。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20product%20photography%20of%20a%20neatly%20folded%20neutral%20beige%20cotton%20garment%20on%20a%20clean%20soft%20light%20background%2C%20studio%20lighting%2C%20warm%20neutral%20tones%2C%20elegant%20and%20simple%20composition&width=1000&height=1000&seq=product-01&orientation=squarish",
    category: "经典系列",
    author: "产品企划部",
    date: "2025-09-30",
    tags: ["经典系列", "基础款", "长绒棉"],
    body: [
      "云舒基础款是白峰美羽最常被推荐的一件产品，也是品牌材质标准的起点。它使用精选长绒棉为主体，纱线密度经过反复试验，兼顾柔软与挺括。",
      "柔光后整理工艺让面料在自然光下呈现细腻的哑光质感，长时间穿着后仍能保持良好形状。",
      "配色以低饱和中性色为主，便于与衣橱中的其他单品搭配，适合长期穿着。",
      "养护建议：建议温和手洗或使用羊毛档机洗，避免高温烘干，以延长使用周期。",
    ],
  },
  {
    id: "p2",
    type: "product",
    title: "星选系列 · 暮山",
    summary:
      "春季新色，由低饱和灰蓝过渡到暖褐，安静而有层次，是本季最受关注的质感单品。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20product%20photography%20of%20a%20soft%20muted%20blue%20and%20brown%20gradient%20fabric%20item%20on%20clean%20light%20background%2C%20studio%20lighting%2C%20refined%20neutral%20palette%2C%20elegant%20simple%20composition&width=1000&height=1000&seq=product-02&orientation=squarish",
    category: "星选系列",
    author: "产品企划部",
    date: "2025-09-20",
    tags: ["星选系列", "新色", "春季"],
    body: [
      "暮山是星选系列本季的主推配色，灵感来自春日傍晚的山影，用色彩讲述安静而深远的气质。",
      "面料采用品牌自研的柔光后整理，让灰蓝到暖褐的过渡更加自然细腻。",
      "设计上延续星选系列的细节语言：简洁的线条、克制的收边，以及一枚低调的品牌标识。",
      "适合希望在日常中保留一点仪式感的用户。",
    ],
  },
  {
    id: "p3",
    type: "product",
    title: "轻享系列 · 微光",
    summary:
      "面向通勤场景的轻量单品，强调透气与易打理，在忙碌的日常里提供不费力的舒适。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20product%20photography%20of%20a%20lightweight%20soft%20gray%20fabric%20item%20on%20a%20clean%20bright%20background%2C%20studio%20lighting%2C%20airy%20neutral%20tones%2C%20elegant%20simple%20composition&width=1000&height=1000&seq=product-03&orientation=squarish",
    category: "轻享系列",
    author: "产品企划部",
    date: "2025-09-05",
    tags: ["轻享系列", "通勤", "透气"],
    body: [
      "微光来自轻享系列，是为通勤场景设计的轻量单品。面料经过轻薄化处理，在保持质感的同时提升透气性。",
      "结构上强调易打理：抗皱与快干的后整理，让日常养护变得更简单。",
      "配色以浅灰与米白为主，视觉上轻盈干净，适合与多种风格搭配。",
      "品牌提示：轻享系列更适合高频使用，建议定期使用温和洗涤剂清洗。",
    ],
  },
  {
    id: "p4",
    type: "product",
    title: "限定系列 · 霜白",
    summary:
      "以冬日晨霜为灵感的限定单品，全球限量 500 套，采用最高等级天然材质与手工收边工艺。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20product%20photography%20of%20a%20frost%20white%20premium%20fabric%20item%20with%20subtle%20hand%20stitching%2C%20clean%20soft%20gray%20background%2C%20cool%20gentle%20studio%20lighting%2C%20elegant%20refined%20composition&width=1000&height=1000&seq=product-04&orientation=squarish",
    category: "限定系列",
    author: "产品企划部",
    date: "2025-08-28",
    tags: ["限定系列", "收藏", "手工"],
    body: [
      "霜白是白峰美羽的限定系列作品，以冬日清晨的霜白为灵感，全球限量 500 套，每套附独立编号证书。",
      "该系列采用品牌最高等级的天然材质，并以更精细的手工工艺完成收边，呈现近乎无痕的质感。",
      "设计上保留了品牌的克制语言，仅在细节处使用一点暖金作为提示。",
      "由于工艺复杂，霜白不接受批量定制，建议提前预约。",
    ],
  },
  {
    id: "p5",
    type: "product",
    title: "经典系列 · 素影高支",
    summary:
      "高支纱线的进阶之选，质地更为细腻挺括，适合对结构与垂坠有更高要求的用户。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20product%20photography%20of%20a%20structured%20high%20count%20fabric%20item%20in%20deep%20neutral%20tone%20on%20clean%20light%20background%2C%20studio%20lighting%2C%20refined%20elegant%20composition%2C%20subtle%20texture%20detail&width=1000&height=1000&seq=product-05&orientation=squarish",
    category: "经典系列",
    author: "产品企划部",
    date: "2025-08-12",
    tags: ["经典系列", "高支", "结构"],
    body: [
      "素影高支使用更高支数的纱线，面料质地更为细腻，同时保持了良好的挺括与垂坠感。",
      "它为对结构与轮廓有更高要求的用户而设计，在正式与日常之间找到平衡。",
      "细节上采用更精细的走线与收边，让整体的线条感更加清晰。",
      "养护建议：建议干洗或使用轻柔手洗，平铺阴干以保持形状。",
    ],
  },
  {
    id: "p6",
    type: "product",
    title: "星选系列 · 拾光",
    summary:
      "以暖金点缀的星选单品，在克制的基底上加入一点点仪式感，适合作为礼物或纪念之选。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20product%20photography%20of%20a%20neutral%20fabric%20item%20with%20subtle%20warm%20gold%20accent%20detail%2C%20clean%20beige%20background%2C%20soft%20studio%20lighting%2C%20elegant%20refined%20composition&width=1000&height=1000&seq=product-06&orientation=squarish",
    category: "星选系列",
    author: "产品企划部",
    date: "2025-07-18",
    tags: ["星选系列", "礼物", "暖金"],
    body: [
      "拾光来自星选系列，在克制的中性基底上，以一点暖金作为提示，为日常加入轻微的仪式感。",
      "细节处的金属色泽经过哑光处理，避免过度张扬，与整体气质保持一致。",
      "包装采用可回收材质，并附赠养护说明卡，适合作为礼物或纪念之选。",
      "品牌提示：为保持金属细节的光泽，建议避免与尖锐物品长时间摩擦。",
    ],
  },
];

export const allContent: ContentItem[] = [...brandStories, ...newsItems, ...productItems];

export interface TeamMember {
  id: string;
  name: string;
  role: string;
  photo: string;
  bio: string;
}

export const teamMembers: TeamMember[] = [
  {
    id: "t1",
    name: "林之 White",
    role: "品牌创始人 / 创意总监",
    photo:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20an%20elegant%20asian%20woman%20designer%20in%20minimal%20neutral%20outfit%2C%20soft%20studio%20lighting%2C%20warm%20beige%20background%2C%20calm%20confident%20expression%2C%20editorial%20photography&width=600&height=600&seq=team-01&orientation=squarish",
    bio: "纺织与设计行业二十年从业经验，主导品牌审美体系的建立，坚信克制是最有力量的表达。",
  },
  {
    id: "t2",
    name: "苏晚 Yu",
    role: "设计中心负责人",
    photo:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20refined%20asian%20man%20designer%20in%20a%20neutral%20knit%20top%2C%20soft%20studio%20lighting%2C%20warm%20beige%20background%2C%20thoughtful%20calm%20expression%2C%20editorial%20photography&width=600&height=600&seq=team-02&orientation=squarish",
    bio: "负责品牌产品结构、比例与细节的打磨，强调每一件设计都应当能被清楚地讲出来。",
  },
  {
    id: "t3",
    name: "陈叙 Xu",
    role: "材质研究负责人",
    photo:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20an%20asian%20woman%20material%20researcher%20in%20a%20light%20shirt%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20gentle%20focused%20expression%2C%20editorial%20photography&width=600&height=600&seq=team-03&orientation=squarish",
    bio: "长期深入供应链一线，建立品牌的材质追溯标准，是「材质的诚实」最重要的推动者。",
  },
  {
    id: "t4",
    name: "何以 Ming",
    role: "客户体验负责人",
    photo:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20friendly%20asian%20man%20in%20a%20minimal%20neutral%20outfit%2C%20soft%20studio%20lighting%2C%20warm%20beige%20background%2C%20warm%20approachable%20expression%2C%20editorial%20photography&width=600&height=600&seq=team-04&orientation=squarish",
    bio: "负责把服务当作产品来设计，坚持「把用户当作长期相处的朋友」这一朴素准则。",
  },
];

export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export const milestones: Milestone[] = [
  {
    year: "2009",
    title: "品牌诞生",
    description: "三位伙伴在杭州西郊的旧厂房工作室创立白峰美羽，从基础面料研究起步。",
  },
  {
    year: "2015",
    title: "首个成体系产品系列",
    description: "发布首个完整产品系列，确立「质感可以被讲述」的品牌表达。",
  },
  {
    year: "2021",
    title: "品牌美学中心落成",
    description: "杭州品牌美学中心启用，集合材质图书馆、打样工坊与公众工作坊。",
  },
  {
    year: "2023",
    title: "多地体验空间布局",
    description: "品牌体验空间相继落地上海、深圳与成都，产品与空间形成呼应。",
  },
  {
    year: "2025",
    title: "可持续路线图发布",
    description: "面向 2030 年的可持续发展承诺公开发布，并启动养护与回收计划。",
  },
];

export interface StatItem {
  value: string;
  label: string;
}

export const brandStats: StatItem[] = [
  { value: "16", label: "年品牌沉淀" },
  { value: "80%+", label: "天然材质占比" },
  { value: "200+", label: "材质样本收藏" },
  { value: "12", label: "城市体验空间" },
];